import ModuleConfig from './moduleConfig.json'

export default defineAppConfig(ModuleConfig)
